import axios from 'axios';
import { urlLetter } from '../utils';

export const apiLetter = axios.create({
    baseURL: `${urlLetter}`,
    headers: {
        'Authorization': 'Basic bWljb29wZTptaWNvb3BlMTIzNA=='
    },
    responseType: 'blob'
});